import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '../../../../environments/environment';
import {UserDTO} from '../models/user-dto';
import {publishReplay, refCount} from 'rxjs/operators';
import {KeycloakService} from 'keycloak-angular';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  private authenticatedUser: Observable<UserDTO>;

  constructor(private http: HttpClient, private keycloakService: KeycloakService) {
  }

  public getUser(): Observable<UserDTO> {
    if (!this.authenticatedUser) {
      this.authenticatedUser = this.http
        .get<UserDTO>(environment + '/me')
        .pipe(publishReplay(1), refCount());
    }
    return this.authenticatedUser;
  }

  clearCachedUserProfile() {
    this.authenticatedUser = null;
  }

  logout() {
    this.keycloakService.logout(environment.feUrl).then(() => {
      this.keycloakService.login({ redirectUri: environment.feUrl });
      this.clearCachedUserProfile();
    });
  }

}
